import { IonContent, IonPage, useIonRouter } from '@ionic/react'

import { useCreateClient } from '../../../hooks/clients/mutations'
import { useIsAdminRoute } from '../../../hooks/routing'
import { useCheckInValues } from '../../../check-in/check-in-store'
import { useOptInClient } from '../../../marketing/customer-opt-in/mutations'
import { CustomerCheckInForm } from '../../../rotate/components/customer-check-in-form'
import { useCheckIn } from '../../../check-in/paired/mutations'

import type { CheckInFormInputs } from '../../../schema/add-client.schema'

function PairedAddCustomerPage() {
  const router = useIonRouter()

  const initialValues = useCheckInValues()
  const createClient = useCreateClient()
  const optInClient = useOptInClient()
  const isAdminRoute = useIsAdminRoute()
  const checkIn = useCheckIn()

  const isDisabled =
    createClient.isLoading || optInClient.isLoading || checkIn.isLoading

  const redirectUrl = isAdminRoute
    ? '/check-in/paired/admin/redeem-loyalty'
    : '/check-in/paired/loyalty-info'

  function handleSubmit(formData: CheckInFormInputs) {
    createClient.mutate(formData, {
      onSuccess: (clientData) => {
        // if customer got here from email check-in, do not opt-in
        if (initialValues.email)
          // TODO: can we use fromdata?
          return router.push(
            `${redirectUrl}?clientId=${clientData.result.client.objectId}`,
            'none',
            'replace'
          )

        if (!initialValues.phoneNumber) return // TODO: do we need this? Can we just use formdata and remove the line

        // Came from Phone Check-In
        if (isAdminRoute)
          return checkIn.mutate(
            {
              checkInMethod: { phone: formData.phoneNumber },
              clientId: clientData.result.client.objectId,
              type: 'pos',
            },
            {
              onSuccess: (stationClientData) =>
                router.push(
                  `${redirectUrl}?clientId=${clientData.result.client.objectId}&stationClientId=${stationClientData.stationClient.objectId}`,
                  'none',
                  'replace'
                ),
            }
          )

        return optInClient.mutate(formData.phoneNumber, {
          onSuccess: () =>
            router.push(
              `${redirectUrl}?clientId=${clientData.result.client.objectId}`,
              'none',
              'replace'
            ),
        })
      },
    })
  }

  return (
    <IonPage>
      <IonContent>
        <div className="mx-auto flex max-w-xl flex-col items-center">
          <CustomerCheckInForm
            disabled={isDisabled}
            initialValues={initialValues}
            onSubmit={handleSubmit}
          />
        </div>
      </IonContent>
    </IonPage>
  )
}

export { PairedAddCustomerPage }
